<template>
  <div class="page forbit-cancel-tree">
    <Modal
      v-model="importModal"
      class="page-modal"
      width="45%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('deviceSip.importAddr')"
      class-name="vertical-center-modal"
    >
      <div class="main-box margin-bottom-20">
        <div class="left-box">
          <form id="uploadExcel">
            <div class="upload-box">
              <a href="javascript:;" class="file">
                <Icon type="md-cloud-upload" class="upload-icon" />
                <input
                  ref="xmlFile"
                  type="file"
                  name="addrBook"
                  accept="text/xml, application/xml"
                  @change="showPic($event)"
                />
              </a>
            </div>
          </form>
          <span>{{ uploadTip }}</span>
          <div class="secret-box">
            <span>{{ $t("updateNewSip.secret") }}</span>
            <div class="secret-input">
              <Input
                v-model="secret"
                type="text"
                size="large"
                :placeholder="$t('updateNewSip.secretTip')"
                maxlength="32"
              ></Input>
              <h4>
                <Icon type="md-information-circle" ssize="30" color="#fc7790" />
                {{ $t("updateNewSip.noSecretTip") }}
              </h4>
            </div>
          </div>
          <div class="detailBackBtn">
            <Button type="default" size="large" @click="backBtn">{{
              $t("common.cancel")
            }}</Button>
            <Button type="primary" size="large" @click="uploadEx">{{
              $t("common.submit")
            }}</Button>
          </div>
        </div>
      </div>
    </Modal>
    <div class="content_win"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "importModal",
  components: {},
  data() {
    return {
      importModal: false,
      modalType: false,
      uploadTip: this.$t("deviceSip.xmlTip"),
      batchType: 0, // 批量上传类型 1-住户 2-访客 3-工作人员 4-黑名单
      url: "",
      fileObj: "",
      secret: "",
    };
  },
  computed: {
    // 离线配置改动点5
    ...mapState("projectConfig", [
      "projectInfo",
      "areaDeviceData",
      "fileVersion",
    ]),
  },
  watch: {
    importModal: {
      handler() {
        if (!this.importModal) {
          let file = document.getElementById("uploadExcel");
          file.value = "";
          this.uploadTip = this.$t("deviceSip.xmlTip");
          this.fileObj = "";
          document.getElementById("uploadExcel").reset();

          this.secret = "";
        }
      },
    },
  },
  mounted() {},
  methods: {
    backBtn() {
      this.importModal = false;
    },
    showPic($event) {
      let file = this.$common.showXML($event);
      if (!file) {
        this.$refs.xmlFile.value = "";
      }
      let name = file.name;
      this.uploadTip = name;
      if (!this.uploadTip) {
        this.uploadTip = this.$t("deviceSip.xmlTip");
      }
      this.fileObj = file;
      this.$forceUpdate();
    },
    uploadEx() {
      if (this.fileObj == "") {
        this.$Message.error(this.$t("deviceSip.xmlTip1"));
      } else {
        this.parseAddrBook();
      }
    },
    // 离线配置改动点4
    // 解析xml文件
    parseAddrBook() {
      let formData = new FormData();
      formData.append("addrBook", this.fileObj);
      if (this.secret.length > 0) {
        formData.append("secret", this.secret);
      }

      this.$store
        .dispatch("projectConfig/parseAddrBook", formData)
        .then((response) => {
          debugger;
          const res = response.result;
          let areaDeviceData = [];
          let projectInfo = res.project; // 小区的项目配置信息
          let fileVersion = ""; // 文件版本
          // 存在文件版本
          if (res.fileVersion && res.fileVersion.version) {
            fileVersion = res.fileVersion.version; // 文件的版本
          } else {
            fileVersion = 0;
          }

          // 最外层设备需要并入树形结构中
          if (res.addressDeviceList) {
            let topDevice = {
              isTopDevice: true,
              name: this.$t("deviceSip.list"),
              title: this.$t("deviceSip.list"),
              groupList: res.addressDeviceList,
            };
            areaDeviceData = res.addressGroupList;
            areaDeviceData.unshift(topDevice);
          } else {
            if (res.addressGroupList) {
              areaDeviceData = res.addressGroupList;
            } else {
              areaDeviceData = [];
            }
          }

          // 设置区域设备信息
          this.$store.commit(
            "projectConfig/SET_AREADEVICEDATA",
            areaDeviceData
          );
          // 设置项目信息
          this.$store.commit("projectConfig/SET_PROJECTINFO", projectInfo);
          // 设置文件版本信息
          this.$store.commit("projectConfig/SET_FILEVERSION", fileVersion);

          this.$Message.success(this.$t("updateNewSip.successxml"));
          this.importModal = false;
          this.$emit("updateTree", this.uploadTip);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  .right-box,
  .left-box {
    width: 100%;
    cursor: pointer;
    text-align: center;
  }
  .line {
    display: block;
    background: #efefef;
    height: 153px;
    width: 2px;
  }

  .upload-icon {
    font-size: 80px;
    display: block;
  }

  .btn-group {
    display: flex;
    justify-content: space-around;
    width: 40%;
    margin: 40px auto 0;
  }
}
.file {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: auto;
  height: auto;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.secret-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 50px;
  span {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-top: -15px;
  }
  div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
  }
  .secret-input {
    width: 70%;
  }
}
</style>
